var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatTeardropText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6563 35.4363H7.82031C7.48672 35.4363 7.16679 35.3038 6.9309 35.0679C6.69502 34.832 6.5625 34.5121 6.5625 34.1785V20.3425C6.5625 18.3604 6.95291 16.3976 7.71144 14.5664C8.46997 12.7351 9.58177 11.0712 10.9833 9.66963C12.3849 8.26805 14.0488 7.15625 15.8801 6.39772C17.7114 5.63919 19.6741 5.24878 21.6562 5.24878H21.6562C23.6384 5.24878 25.6011 5.63919 27.4324 6.39772C29.2636 7.15625 30.9276 8.26805 32.3291 9.66964C33.7307 11.0712 34.8425 12.7351 35.6011 14.5664C36.3596 16.3977 36.75 18.3604 36.75 20.3425V20.3426C36.75 24.3457 35.1598 28.1848 32.3292 31.0154C29.4985 33.8461 25.6594 35.4363 21.6563 35.4363Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 18.3738H26.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 23.6238H26.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTeardropText);
export default __webpack_public_path__ + "static/media/chatTeardropText.de1f96c9af361140ddb7e22474975502.svg";
export { ForwardRef as ReactComponent };